import { InvalidUserLoginRequest } from '@usecases/user-login.usecase';
import type { BaseController } from '@infra/controllers/base.controller';
import type {
  UserSSOLoginRequest,
  UserSSOLoginUsecase,
} from '../usecases/user-sso-login.usecase';

export type UserSSOLoginInput = UserSSOLoginRequest;

export type UserSSOLoginOutput = InvalidUserLoginRequest | void;

export class UserSSOLoginController
  implements BaseController<UserSSOLoginInput, UserSSOLoginOutput>
{
  constructor(private usecase: UserSSOLoginUsecase) {}

  async handle(req: UserSSOLoginInput): Promise<UserSSOLoginOutput> {
    try {
      await this.usecase.run(req);
    } catch (error) {
      if (error instanceof InvalidUserLoginRequest) {
        return error;
      }

      throw error;
    }
  }
}
